import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '@aws-amplify/auth';
import { useAuth } from './AuthProvider';
import {
  Container,
  Spinner,
  Alert,
  Box,
  SpaceBetween
} from '@cloudscape-design/components';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Check if user is now authenticated after OAuth redirect
        const user = await getCurrentUser();
        
        if (user) {
          // Refresh auth state in provider
          await refreshAuth();
          
          // Redirect to main app
          navigate('/', { replace: true });
        } else {
          setError('Authentication failed. Please try again.');
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError('Authentication failed. Please try again.');
        
        // Redirect back to login after a delay
        setTimeout(() => {
          navigate('/auth', { replace: true });
        }, 3000);
      }
    };

    handleAuthCallback();
  }, [navigate, refreshAuth]);

  if (error) {
    return (
      <Container>
        <SpaceBetween size="l">
          <Alert type="error">
            {error}
          </Alert>
          <Box textAlign="center">
            Redirecting to login page...
          </Box>
        </SpaceBetween>
      </Container>
    );
  }

  return (
    <Container>
      <Box textAlign="center">
        <SpaceBetween size="l">
          <Spinner size="large" />
          <Box variant="h3">Completing sign in...</Box>
          <Box color="text-body-secondary">
            Please wait while we complete your authentication.
          </Box>
        </SpaceBetween>
      </Box>
    </Container>
  );
};